'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getUserAttributes", "setUserAttribute", "attributeKey"];
import PropTypes from 'prop-types';
import TipAlert from './TipAlert';
import useUserAttribute from '../hooks/useUserAttribute';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CloseableTipAlert(props) {
  const {
      getUserAttributes,
      setUserAttribute,
      attributeKey
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [attributeLoaded, hasAttribute, setHasAttribute] = useUserAttribute(getUserAttributes, setUserAttribute, attributeKey);
  if (!attributeLoaded || hasAttribute) {
    return null;
  }
  return /*#__PURE__*/_jsx(TipAlert, Object.assign({}, rest, {
    closeable: true,
    onClose: () => setHasAttribute(true)
  }));
}
CloseableTipAlert.propTypes = Object.assign({}, TipAlert.propTypes, {
  getUserAttributes: PropTypes.func.isRequired,
  setUserAttribute: PropTypes.func.isRequired,
  attributeKey: PropTypes.string.isRequired
});